<div class="form-group" [ngClass]="{'has-error': !!errors }">
  <label class="control-label" [htmlFor]="controlName">
    {{ schemaTranslations?.getFieldTranslation(controlName) }}
    @if (properties.isFieldRequired(controlName)) {
      <span class="required">*</span>
    }
  </label>
  @if (properties.getEnumValues(controlName).length < RADIO_TO_SELECT_BREAKPOINT) {
    <div class="btn-radio-group" btnRadioGroup [formControl]="formControl">
      @for (value of properties.getEnumValues(controlName); track value) {
        <label
          [btnRadio]="value"
          class="btn-radio">
          {{ schemaTranslations?.getEnumTranslation(controlName, value) }}
        </label>
      }
    </div>
    @if (!properties.isFieldRequired(controlName)) {
      <button
        class="btn btn-default btn-raised btn-sm" type="button" (click)="formControl.patchValue('')">
        <i class="icon icon-times"></i> {{ 'profile-form.property-single-enum.reset_property' | translate }}
      </button>
    }
  } @else {
    <select [formControl]="formControl"
      class="form-control"
      #input
      id="{{ controlName }}"
      [required]="properties.isFieldRequired(controlName)">
      <option value="">{{'generic.default_select_value'  | translate}}</option>
      @for (enumValue of properties.getEnumValues(controlName); track enumValue) {
        <option [value]="enumValue">
          {{ (isInteger) ? enumValue : schemaTranslations?.getEnumTranslation(controlName, enumValue) }}
        </option>
      }
    </select>
  }
</div>
